<template>
  <div
    ref="dropdown"
    class="relative inline-block text-left"
  >
    <!-- Dropdown Toggle Button -->
    <button
      :class="buttonClass"
      @click="toggleDropdown"
    >
      <img
        src="../../assets/images/message-icon.png"
        alt="Message Icon"
        class="mobile:w-5 mobile:h-5 laptop:w-5 laptop:h-5 largeDesktop:w-7 largeDesktop:h-7 object-contain"
      >
      <div class="flex gap-1 items-center">
        <span class="inline-block mobile:w-1 mobile:h-1 laptop:w-2 laptop:h-2 largeDesktop:w-2 largeDesktop:h-2 rounded-full bg-purple-800"></span>
        <span class="inline-block">Messages</span>
      </div>
    </button>

    <!-- Dropdown Menu -->
    <!-- <div
      v-if="isOpen"
      class="origin-top-right absolute mobile:-right-[180px] tablet:right-0 mt-2 w-72 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50"
    >
      <ul class="list-inline mb-0 p-0  max-h-60 overflow-auto">
        <li>
          <a
            class="block px-2 py-2 text-sm no-underline cursor-pointer text-gray-700 hover:bg-gray-100"
          >Dashboard</a>
        </li>
        <li>
          <a class="block px-2 py-2 text-sm no-underline cursor-pointer text-gray-700 hover:bg-gray-100">Lorem
            Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been
            the industry's standard dummy text ever since the 1500s,</a>
        </li>
        <li>
          <a
            class="block px-2 py-2 text-sm no-underline cursor-pointer text-gray-700 hover:bg-gray-100"
          >Dashboard</a>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
export default {
    props: {
        buttonClass: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isOpen: false,
        };
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        handleClickOutside(event) {
            const dropdown = this.$refs.dropdown;
            if (dropdown && !dropdown.contains(event.target)) {
                this.isOpen = false;
            }
        },
    },
};
</script>